import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { map } from 'rxjs';
import { LangService } from 'src/app/shared-module';

@Component({
  selector: 'app-legal',
  templateUrl: './legal.component.html',
  styleUrls: ['./legal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LegalComponent {
  @Input() url = '/legal';

  private currentLang$ = this.langService.currentLang$;

  public termsAndConditionsUrl$ = this.currentLang$.pipe(
    map((lang) => `assets/doc/GCU-Wellnot-${lang.toUpperCase()}.pdf`),
  );
  public termsOfSalesUrl$ = this.currentLang$.pipe(map((lang) => `assets/doc/CGV-Wellnot-${lang.toUpperCase()}.pdf`));
  public privacyPolicyUrl$ = this.currentLang$.pipe(map((lang) => `assets/doc/PC-Wellnot-${lang.toUpperCase()}.pdf`));

  constructor(private langService: LangService) {}
}
